'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { CONTENT_PLACEHOLDER } from 'my-purchases/constants/constants'
import { dateFormatter } from 'utils/dateFormatter/dateFormatter'

interface PurchaseDateProps {
	readonly date: string
	readonly className?: string
}

export function PurchaseDate({ date, className }: PurchaseDateProps) {
	const { t } = useLabels()
	const {
		country: { locale },
	} = useMasterData()
	const purchasedDate = dateFormatter({ dateString: date, locale })

	return (
		<div className={className} data-testid='myPurchases.details.purchaseDate'>
			<h2>{t('myPurchases.details.purchaseDate.title')}</h2>
			<p>
				{purchasedDate === 'Invalid Date' ? CONTENT_PLACEHOLDER : purchasedDate}
			</p>
		</div>
	)
}
